
// import React, { useState, useEffect, useCallback } from "react";
// import UserLayout from "../utils/user/UserLayout";
// import { useDispatch } from "react-redux";
// import { connect } from "react-redux";
// import { Link } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import { IMAGEAPI } from "../../BackendConnections";
// import "react-toastify/dist/ReactToastify.css";
// import Select from "react-select";
// import {
//   fetchProfileAction,
//   updateProfleAction,
//   updateProflePicAction,
// } from "../../redux/actions/user/userAction";
// import {
//   fetchCountriesAction,
//   fetchSectorAction,
//   fetchStatutoryIndustryAction,
//   fetchPhasesAction,
//   fetchOrganisationAction,
//   fetchCompetenciesScoreAction,
//   fetchPersonalSkillsAction,
//   fetchQualificationsAction,
//   fetchEducationsAction,
//   fetchFunctionsAction,
//   fetchCategoryAction,
//   fetchJobTitlesAction,
//   fetchSystemAction,
//   fetchSystemExperienceAction,
//   fetchSystemsExpereinceScoringAction,
//   fetchJobTitlesGrade,
//   fetchRegion,
// } from "../../redux/actions/admin/adminAction";
// import Sector from "./forms/Sector";
// import Phase from "./forms/Phase";
// import Organisation from "./forms/Organisation";
// import Regions from "./forms/Regions";
// import Function from "./forms/Function";
// import Category from "./forms/Category";
// import JobTitle from "./forms/JobTitle";
// import EmploymentHistory from "./forms/EmploymentHistory";
// import Qualification from "./forms/Qualification";
// import StatutoryIndustryTraining from "./forms/StatutoryIndustryTraining";
// import SystemExperience from "./forms/SystemExperience";
// import CompetenciesScore from "./forms/CompetenciesScore";
// import PersonalSkills from "./forms/PersonalSkills";
// import { DialogLeavingPage } from "../utils/core/blocknavigation/DialogLeavingPage";
// import { useNavigatingAway } from "../utils/core/blocknavigation/useNavigatingAway";
// import Modal from "react-bootstrap/Modal";
// import Cropper from "react-easy-crop";
// import { cropImage } from "./helper/cropUtils";
// import { Button } from "react-bootstrap";
// import getCroppedImg from "./helper/croperimg";
// import axiosInstance from "../authentication/helper/axiosApi";
// import axios from "axios";
// // import './styleCroper.css'
// import heic2any from "heic2any";


// export const Profile = (props) => {
  

//   const dispatch = useDispatch();
//   const customStyles = {
//     control: (base, state) => ({
//       ...base,
//       top: "5px",
//       // Overwrittes the different states of border
//       borderColor: state.isFocused ? "#309CCA" : "#309CCA",
//     }),
//   };

//   const [image, setImage] = useState(["/assets/images/preview-img.png"]);
//   const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
//   const [rotation, setRotation] = useState(0);
//   const [inputData, setInputData] = useState({});

//   const MAX_COMPANY_CHARS = 28;

//   const [professionalCharCount, setProfessionalCharCount] = useState(0);






//   // console.log(inputData);

//   // const [isvalid, seIsvalid] = useState(true);

//   const [isEnable, setIsEnable] = useState({
//     profile_pic: false,
//     save: false,
//     proffesional_snyposis: false,
//   });
//   const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
//     useState(false);
//   const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
//     useNavigatingAway(canShowDialogLeavingPage);

//   const [selected, setSelected] = useState({
//     primary_sector: null,
//     secondary_sector: null,
//     primary_function: null,
//     secondary_function: null,
//   });



//   const resizeAndCompress = (file, maxSize = 800, quality = 0.6) => {
//   return new Promise((resolve) => {
//     const reader = new FileReader();

//     reader.onload = (e) => {
//       const img = new Image();
//       img.onload = () => {
//         let width = img.width;
//         let height = img.height;

//         // Resize preserving aspect ratio
//         if (width > height) {
//           if (width > maxSize) {
//             height = Math.round((height * maxSize) / width);
//             width = maxSize;
//           }
//         } else {
//           if (height > maxSize) {
//             width = Math.round((width * maxSize) / height);
//             height = maxSize;
//           }
//         }

//         const canvas = document.createElement("canvas");
//         canvas.width = width;
//         canvas.height = height;
//         const ctx = canvas.getContext("2d");

//         ctx.drawImage(img, 0, 0, width, height);

//         canvas.toBlob(
//           (blob) => resolve(blob),
//           "image/jpeg",
//           quality
//         );
//       };
//       img.src = e.target.result;
//     };

//     reader.readAsDataURL(file);
//   });
// };




//   // const [onChange, setOnChange] = useState({
//   //     image: false,
//   //     userDetails: false,
//   //     sector: false,
//   //     phase: false,
//   //     organisation: false,
//   //     region: false,
//   //     function: false,
//   //     category: false,
//   //     jobTitle: false,
//   //     qualification: false,
//   //     statutory: false,
//   //     systemsExperience: false,
//   //     competenceScore: false,
//   //     personalSkills: false,
//   // });
//   const [show, setShow] = useState(false);
//   const [crop, setCrop] = useState({
//     x: 0,
//     y: 0,
//     // width: 540,
//     // height: 360,
//   });
//   const imageContainerStyles = {
//     width: "auto !important",
//     maxWidth: "100% !important",
//     height: "auto !important",
//   };
//   const [zoom, setZoom] = useState(1);
//   const [croppedImage, setCroppedImage] = useState(null);
//   // console.log(croppedImage);
//   useEffect(() => {
//     if (Object.keys(props.profile).length > 0) {
//       const profileDetails = {
//         userId: props.profile.userId,
//         first_name: props.profile.first_name,
//         last_name: props.profile.last_name,
//         location: props.profile.location,
//         // telephone_number: props.profile.telephone_number,
//         // phone_number: props.profile.phone_number,
//         profile_pic: props.profile.profile_pic,
//         professionalSynopsis: props.profile.professionalSynopsis,
//         profile_fill: props.profile.profile_fill,
//       };
//       const selectedData = {
//         primary_sector: props.profile.primary_sector,
//         secondary_sector: props.profile.secondary_sector,
//         primary_function: props.profile.primary_function,
//         secondary_function: props.profile.secondary_function,
//       };
//       setSelected(selectedData);
//       setInputData(profileDetails);
//        // Initialize character count for Professional Synopsis
//       setProfessionalCharCount(
//         profileDetails.professionalSynopsis
//           ? profileDetails.professionalSynopsis.length
//           : 0
//       );
//     }

//     if (props.profile.profile_pic !== null) {
//       setImage(IMAGEAPI + props.profile.profile_pic);
//     } else {
//       setImage("/assets/images/preview-img.png");
//     }
//   }, [props.profile, props.profileData]);

//   const handleChangeProffesional = (event) => {
//     setIsEnable((prevState) => ({ ...prevState, proffesional_snyposis: true }));
//     setCanShowDialogLeavingPage(true);

//     const rawValue = event.target.value || "";
//     const limitedValue = rawValue.slice(0, 1000); // Enforce 1000 characters

//     setInputData((prevState) => ({
//       ...prevState,
//       [event.target.name]: limitedValue,
//     }));

//     // Update live character counter
//     setProfessionalCharCount(limitedValue.length);
//   };


//   const handleProffesionalFormSubmit = (event) => {
//     event.preventDefault();
//     const profileDetails = {
//       userId: inputData.userId,
//       professionalSynopsis: inputData.professionalSynopsis,
//     };
//     dispatch(updateProfleAction(inputData.userId, profileDetails));
//     setIsEnable((prevState) => ({
//       ...prevState,
//       proffesional_snyposis: false,
//     }));
//     setCanShowDialogLeavingPage(false);
//   };

//   //   const onCropComplete = (croppedArea, croppedAreaPixels) => {
//   //     cropImage(image, croppedAreaPixels, console.log).then((result)   => {
//   //       setCroppedImage(result);
//   // // setImage(result)
//   //       setInputData((prevData) => ({
//   //         ...prevData,
//   //         profile_pic: result,
//   //       }));
//   //     });
//   //   };

//   const onCropComplete = (croppedArea, croppedAreaPixels) => {
//     setCroppedAreaPixels(croppedAreaPixels)
//     // console.log(croppedAreaPixels);
//     cropImage(image, croppedAreaPixels).then((result) => {
//       setCroppedImage(result)

//     })
//   };

//   // const handleChangeImage = (event) => {
//   //   event.preventDefault();
//   //   setIsEnable((prevState) => ({ ...prevState, profile_pic: true }));
//   //   setCanShowDialogLeavingPage(true);
//   //   const fieldName = event.target.getAttribute("name");
//   //   const fieldValue = event.target.files[0];
//   //   const newFormData = { ...props.profile };
//   //   newFormData[fieldName] = fieldValue;
//   //   const url = URL.createObjectURL(fieldValue);
//   //   setImage(url);
//   //   // console.log([event.target.name], event.target.files[0]);
//   //   setInputData((prevState) => ({
//   //     ...prevState,
//   //     [event.target.name]: event.target.files[0],
//   //   }));
//   // };



//   const handleChangeImage = async (event) => {
//   const file = event.target.files[0];
//   if (!file) return;

//   setIsEnable(prev => ({ ...prev, profile_pic: true }));
//   setCanShowDialogLeavingPage(true);

//   let finalFile = file;

//   // Detect HEIC / HEIF
//   const isHeic =
//     file.type.includes("heic") ||
//     file.type.includes("heif") ||
//     file.name.toLowerCase().endsWith(".heic") ||
//     file.name.toLowerCase().endsWith(".heif");

//   if (isHeic) {
//     console.log("HEIC detected → converting to JPG...");

//     try {
//       const convertedBlob = await heic2any({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.9,
//       });

//       finalFile = new File(
//         [convertedBlob],
//         file.name.replace(/\.[^/.]+$/, "") + ".jpg",
//         { type: "image/jpeg" }
//       );

//       console.log("HEIC converted successfully:", finalFile);
//     } catch (err) {
//       console.error("HEIC conversion failed:", err);
//       alert("This HEIC image cannot be processed. Please upload JPG/PNG.");
//       return;
//     }
//   }

//   // Convert the new file to preview URL
//   const previewUrl = URL.createObjectURL(finalFile);
//   setImage(previewUrl);

//   // Save the processed file so cropper and backend use JPEG
//   setInputData((prev) => ({
//     ...prev,
//     profile_pic: finalFile,
//   }));
// };

//   // const handeImageSubmit = async () => {
//   //   console.log('croppedImage:', croppedImage);
  
//   //   try {
//   //     const img = new Image();
//   //     img.onload = function () {
//   //       console.log('Image loaded successfully');
//   //       console.log('Image width:', img.width);
//   //       console.log('Image height:', img.height);
  
//   //       const imgUrl = {
//   //         "profile_image": croppedImage,
//   //         "Six-coordinates": {
//   //           "width": img.width,
//   //           "height": img.height,
//   //           // Add other coordinates properties as needed
//   //         },
//   //       };
  
//   //       dispatch(updateProflePicAction(inputData.userId, imgUrl));
//   //       // --- FIX: Reset unsaved state here ---
//   //       setIsEnable(prev => ({ ...prev, profile_pic: false }));
//   //       setCanShowDialogLeavingPage(false);
//   //       setShow(false);
//   //     };
  
//   //     img.onerror = function () {
//   //       console.error('Error loading image:', croppedImage);
//   //     };
  
//   //     img.src = croppedImage;
//   //   } catch (error) {
//   //     console.error(error);
//   //   }
//   // };

//   const handeImageSubmit = async () => {
//   if (!croppedImage) return;

//   try {
//     // Convert base64 cropped image → File
//     const response = await fetch(croppedImage);
//     const blob = await response.blob();
//     const originalFile = new File([blob], "cropped.jpg", { type: "image/jpeg" });

//     // RESIZE + COMPRESS
//     const compressedBlob = await resizeAndCompress(originalFile, 800, 0.6);
//     const compressedFile = new File([compressedBlob], "compressed.jpg", { type: "image/jpeg" });

//     console.log("Original:", (originalFile.size / 1024).toFixed(2), "KB");
//     console.log("Compressed:", (compressedFile.size / 1024).toFixed(2), "KB");

//     const formData = new FormData();
//     formData.append("profile_pic", compressedFile);

//     console.log("Sending to server:", compressedFile);
//     console.log("FormData content:", formData.get("profile_pic"));


//     dispatch(updateProflePicAction(inputData.userId, formData));

//     setIsEnable(prev => ({ ...prev, profile_pic: false }));
//     setCanShowDialogLeavingPage(false);
//     setShow(false);
//   } catch (error) {
//     console.error("Image upload failed:", error);
//   }
// };


  
  
  
  

//   const handleImageFormSubmit = (event) => {
//     event.preventDefault();

//     const profileDetails = {
//       userId: inputData.userId,
//       profile_pic: inputData.profile_pic,
//     };
//     // console.log(profileDetails);
//     dispatch(
//       // updateProflePicAction(inputData.userId, profileDetails, props.profile)
//     );
//     setIsEnable((prevState) => ({ ...prevState, profile_pic: false }));
//     setCanShowDialogLeavingPage(false);
//   };

//   const [isValidForm, setIsValidForm] = useState(true);
//   const [errors, setErrors] = useState({
//     first_name_error: null,
//   });

//   const validateForm = (data) => {
//     const obj = Object.keys(data);
//     let checkValidation = true;
//     obj.forEach((key, index) => {
//       switch (key) {
//         case "first_name":
//           if (data[key] === null || data[key] === "") {
//             setErrors({ first_name_error: "First Name is required!" });
//             checkValidation = false;
//           } else {
//             setErrors({ first_name_error: null });
//           }
//           break;
//         case "last_name":
//           if (data[key] === null || data[key] === "") {
//             setErrors({ last_name_error: "Last Name is required!" });
//             checkValidation = false;
//           } else {
//             setErrors({ last_name_error: null });
//           }
//           break;
//         case "location":
//           break;
//         case "telephone_number":
//           break;
//         case "phone_number":
//           break;
//         default:
//           return isValidForm;
//       }
//     });

//     if (checkValidation === false) {
//       setIsValidForm(false);
//     } else {
//       setIsValidForm(true);
//     }
//   };

//   const handleChange = (event, eventName) => {
//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);
//     if (eventName === "location") {
//       if (event != null) {
//         setInputData((prevState) => ({
//           ...prevState,
//           [eventName]: event["id"],
//         }));
//       } else {
//         setInputData((prevState) => ({ ...prevState, [eventName]: null }));
//       }
//     } else {
//       setInputData((prevState) => ({
//         ...prevState,
//         [event.target.name]: event.target.value,
//       }));
//     }
//   };

//   const handleInputChange = (inputValue) => {
//     const searchValue = inputValue.toLowerCase();
//     const filteredCountries = props.countries.filter((country) =>
//       country.name.toLowerCase().includes(searchValue)
//     );

//     // Sort the filtered countries to prioritize options that start with the input value
//     filteredCountries.sort((a, b) => {
//       const aStartsWithInput = a.name.toLowerCase().startsWith(searchValue);
//       const bStartsWithInput = b.name.toLowerCase().startsWith(searchValue);

//       if (aStartsWithInput && !bStartsWithInput) {
//         return -1;
//       }
//       if (!aStartsWithInput && bStartsWithInput) {
//         return 1;
//       }
//       return 0;
//     });

//     setFilteredOptions(filteredCountries);
//   };
//   const handleChnageLocation = (event) => { };
//   const [filteredOptions, setFilteredOptions] = useState(props.countries);
//   const handleFormSubmit = (event) => {
//     event.preventDefault();
//     const profileDetails = {
//       userId: inputData.userId,
//       first_name: inputData.first_name,
//       last_name: inputData.last_name,
//       location: inputData.location,
//       // telephone_number: inputData.telephone_number,
//       // phone_number: inputData.phone_number,
//     };
//     validateForm(profileDetails);
//     if (isValidForm) {
//       dispatch(updateProfleAction(inputData.userId, profileDetails));
//       setIsEnable((prevState) => ({ ...prevState, save: false }));
//       setCanShowDialogLeavingPage(false);
//     }
//   };

//   const handleChildrenCallback = (childData, childname) => {
//     const name = childname;
//     setSelected((prevState) => ({ ...prevState, [name]: childData }));
//   };

//   const fetchData = useCallback(() => {
//     if (Object.keys(props.countries).length === 0) {
//       props.fetchCountries();
//     }
//     if (Object.keys(props.sector).length === 0) {
//       props.fetchSector();
//     }
//     if (Object.keys(props.statutoryIndustry).length === 0) {
//       props.fetchStatutoryIndustry();
//     }
//     if (Object.keys(props.phases).length === 0) {
//       props.fetchPhases();
//     }
//     if (Object.keys(props.phases).length === 0) {
//       props.fetchOrganisation();
//     }
//     if (Object.keys(props.competenciesScore).length === 0) {
//       props.fetchCompetenciesScore();
//     }
//     if (Object.keys(props.personalSkills).length === 0) {
//       props.fetchPersonalSkills();
//     }
//     if (Object.keys(props.qualifications).length === 0) {
//       props.fetchQualifications();
//     }
//     if (Object.keys(props.educations).length === 0) {
//       props.fetchEducations();
//     }
//     if (Object.keys(props.functions).length === 0) {
//       props.fetchFunctions();
//     }
//     if (Object.keys(props.category).length === 0) {
//       props.fetchCategory();
//     }
//     if (Object.keys(props.jobTitles).length === 0) {
//       props.fetchJobTitles();
//     }
//     if (Object.keys(props.grade).length === 0) {
//       props.fetchJobTitlesGrade();
//     }
//     if (Object.keys(props.region).length === 0) {
//       props.fetchRegion();
//     }
//     if (Object.keys(props.system).length === 0) {
//       props.fetchSystem();
//     }
//     if (Object.keys(props.systemExpereine).length === 0) {
//       props.fetchSystemExperience();
//     }
//     if (Object.keys(props.systemExpereineScoring).length === 0) {
//       props.fetchSystemsExpereinceScoring();
//     }
//   }, [props]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   return (
//     <UserLayout>
//       <ToastContainer
//         position="top-right"
//         autoClose={1000}
//         hideProgressBar
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//       />
//       <div className="right-section">
//         <div className="banner">
//           <div className="banner-title-overlay">
//             <h5>
//               <span>
//                 MY
//                 <br />
//                 <b>Profile</b>
//                 <hr className="bannerhr"
//                   style={{
//                     height: "5px",
//                     background: "white",
//                     width: "75%",
//                   }}
//                 />
//               </span>
//             </h5>
//           <img src="/assets/images/banners/profWhiteIcon.png" className="icon-image" />
// {" "}
//             <div className="col-sm-6 col-12  title-icon-box text-center">
//               <div className="text-center picture-area d-flex justify-content-center">
//   <div>
//                   <div className="profile-upload">
//                     <div className="profile-preview  ">
//                       <div className="img-wrap">
//                         <div className="hexagon-wrap">
//                           <svg
//                             version="1.1"
//                             xmlns="http://www.w3.org/2000/svg"
//                             xmlnsXlink="http://www.w3.org/1999/xlink"
//                             viewBox="0 0 120 90"
//                           >
//                             <defs>
//                             <pattern id="imgupload-profile" patternUnits="userSpaceOnUse" width="150" height="100">
//                                 <image
//                                   xlinkHref={image}
//                                   x="-25"
//                                   width="150"
//                                   height="100"
//                                   className="img-fluid"
//                                 ></image>
//                               </pattern>
//                             </defs>
//                             <polygon fill="url(#imgupload-profile)" points="25.457,92.51 0.914,50 25.457,7.49 74.543,7.49 99.086,50 74.543,92.51 "></polygon>
//                           </svg>
//                         </div>
//                       </div>
//                       <label
//                         className="upload-label "
//                         htmlFor=""
//                         onClick={() => setShow(true)}
//                       >
//                         {/* <input
//                       type="file"
//                       id="upload-image"
//                       name="profile_pic"
//                       onChange={handleChangeImage}
//                       onClick={()=> setShow(true)}
//                     />{" "} */}
//                         Upload Your Image{" "}
//                         <span>
//                           {isEnable.profile_pic ? (
//                             <Link
//                               className="edit-btn"
//                               to=""
//                             // onClick={handleImageFormSubmit}
//                             >
//                               {/* <span>
//                                 <img
//                                   src="/assets/images/icons/save.png"
//                                   alt=""
//                                 />
//                                 Save
//                               </span> */}
//                             </Link>
//                           ) : (
//                             ""
//                           )}
//                         </span>
//                       </label>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//          <img className="banner-image" src="/assets/images/banners/Asset 1.png" alt="" />
//         </div>
        

//         <div className="row picture-area pb-3 mt-5">
//           <div className="col-md-8 col-12">
//             <div className="inner-content">
//               <h6>Let’s get started</h6>
//               <p style={{ fontSize: "16px" }}>
//                 Now develop your own goneet energy industry standard profile and{" "}
//                 establish your position within your own specific discipline.
//               </p>
//               {/* <div className="features">
//                 Create your profile and compare your CV’s strength against your
//                 peers.
//               </div> */}
//             </div>
//           </div>
//           <div className="col-md-4 col-12 mt-2 ">
//             <div className="progress-widget" style={{ paddingRight: "50px" }}>
//               {" "}
//               <label className="progress-label">PROFILE PROGRESS</label>{" "}
//               <div className="progress-block">
//                 {" "}
//                 <div className="progress">
//                   {" "}
//                   <div
//                     className="progress-bar"
//                     role="progressbar"
//                     style={{ width: inputData.profile_fill + "%" }}
//                     aria-valuenow="2"
//                     aria-valuemin="0"
//                     aria-valuemax="100"
//                   ></div>{" "}
//                 </div>{" "}
//                 <span>{inputData.profile_fill}%</span>{" "}
//               </div>{" "}
//             </div>
//           </div>
//         </div>

//         <div className="profile-timeline">
//           {/* <!-- Name --> */}
//           <div className="row single-row">
//             <div className="row-icon completed">
//               {/* <img src="/assets/images/profile-page/my_profile.svg" alt="" /> */}
//               <img
//                 // className="row-icon "
//                 // src="\assets\images\preview-img.png"
//                 // src="/assets/images/profile-page/profile.svg"
//                 src="\assets\images\quick-links\profile.svg"
//                 alt=""
//                 style={{ background: "white" }}
//               />
//             </div>
//             <div className="col-12 mb-2">
//               <label className="timeline-label ">Name</label>
//             </div>
//             <div className="col-md-6 col-12">
//               <div className="single-field mb-3">
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="First Name"
//                   name="first_name"
//                   id="first_name"
//                   required
//                   onChange={(event) => handleChange(event, "first_name")}
//                   defaultValue={inputData.first_name}
//                 />
//               </div>
//               {errors.first_name_error !== null ? (
//                 errors.first_name_error
//               ) : (
//                 <></>
//               )}
//             </div>
//             <div className="col-md-6 col-12">
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Last Name"
//                 name="last_name"
//                 id="last_name"
//                 onChange={(event) => handleChange(event, "last_name")}
//                 defaultValue={inputData.last_name}
//               />
//             </div>
//             {errors.last_name_error !== null ? errors.last_name_error : <></>}
//           </div>

//           {/* <!-- Contact --> */}
//           <div className="row single-row">
//             <div className="row-icon completed">
//               <img
//                 src="/assets/images/profile-page/contact_outline.svg"
//                 alt=""
//               />
//               {/* <img
//                 className="completed"
//                 src="/assets/images/profile-page/contact_outline.svg"
//                 alt=""
//               /> */}
//             </div>
//             <div className="col-md-6 col-12">
//               <label className="timeline-label m-0">Contact</label>
//               <div className="expertise-fields">
//                 <div className="single-field mb-3">
//                   <input
//                     type="email"
//                     className="form-control"
//                     name="email"
//                     id="email"
//                     onChange={(event) => handleChange(event, "email")}
//                     placeholder="Example@gmail.com"
//                     defaultValue={props.user.email}
//                     readOnly
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-6 col-12 cmb-25">
//               <label className="timeline-label m-0">Location</label>
//               <div className="expertise-fields">
//                 <div className="single-field mb-3">
//                   {/* <Select
//                     id="location"
//                     name="location"
//                     value={
//                       props.countries &&
//                       props.countries.find(
//                         (country) => country.id === inputData.location
//                       )
//                     }
//                     options={props.countries}
//                     getOptionLabel={(option) => option.name}
//                     getOptionValue={(option) => option.id}
//                     onChange={(event) => handleChange(event, "location")}
//                     placeholder="Choose..."
//                     isClearable={true}
//                     styles={customStyles}
//                   /> */}
//                   <Select
//                     id="location"
//                     name="location"
//                     placeholder="Choose..."
//                     isClearable={true}
//                     styles={customStyles}
//                     value={
//                       props.countries &&
//                       props.countries.find(
//                         (country) => country.id === inputData.location
//                       )
//                     }
//                     onChange={(event) => handleChange(event, "location")}
//                     onInputChange={(inputValue, actionMeta) => {
//                       handleInputChange(inputValue);
//                     }}
//                     options={filteredOptions} // Use the filteredOptions state here
//                     getOptionLabel={(option) => option.name}
//                     getOptionValue={(option) => option.id}
//                   />
//                 </div>
//               </div>
//             </div>
//             {/* <div className="col-12">
//                             <div className="row">
//                                 <div className="col-md-6 col-12 single-item">
//                                     <input type="number"
//                                         name="telephone_number"
//                                         className="form-control"
//                                         placeholder="Telephone Number"
//                                         onChange={(event) => handleChange(event, "telephone_number")}
//                                         defaultValue={inputData.telephone_number}
//                                     />
//                                 </div>
//                                 <div className="col-md-6 col-12 single-item">
//                                     <input type="number"
//                                         name="phone_number"
//                                         className="form-control"
//                                         placeholder="Phone Number"
//                                         onChange={(event) => handleChange(event, "phone_number")}
//                                         defaultValue={inputData.phone_number}
//                                     />
//                                 </div>
//                             </div>
//                         </div> */}
//           </div>
//           <div className="row single-row-space">
//             <div className="col text-right ">
//               {isEnable.save ? (
//                 <Link className="edit-btn" to="" onClick={handleFormSubmit}>
//                   <span>
//                     <img src="/assets/images/icons/save.png" alt="" />
//                     Save
//                   </span>
//                 </Link>
//               ) : (
//                 ""
//               )}
//             </div>
//           </div>

//           <Sector parentCallback={handleChildrenCallback} />

//           <Phase
//             primarySectorId={selected.primary_sector}
//             secondarySectorId={selected.secondary_sector}
//           />

//           <Organisation
//             primarySectorId={selected.primary_sector}
//             secondarySectorId={selected.secondary_sector}
//           />

//           <Regions
//             primarySectorId={selected.primary_sector}
//             secondarySectorId={selected.secondary_sector}
//           />

//           <Function
//             parentCallback={handleChildrenCallback}
//             primarySectorId={selected.primary_sector}
//             secondarySectorId={selected.secondary_sector}
//           />

//           <Category
//             primaryFunctionId={selected.primary_function}
//             secondaryFunctionId={selected.secondary_function}
//             primarySectorId={selected.primary_sector}
//             secondarySectorId={selected.secondary_sector}
//           />

//           <JobTitle
//             primaryFunctionId={selected.primary_function}
//             secondaryFunctionId={selected.secondary_function}
//             primarySectorId={selected.primary_sector}
//             secondarySectorId={selected.secondary_sector}
//           />

//           <EmploymentHistory
//             primaryFunctionId={selected.primary_function}
//             secondaryFunctionId={selected.secondary_function}
//             primarySectorId={selected.primary_sector}
//             secondarySectorId={selected.secondary_sector}
//           />

//           <Qualification qualificaions={props.qualificaions} />

//           <StatutoryIndustryTraining
//             primarySectorId={selected.primary_sector}
//             secondarySectorId={selected.secondary_sector}
//           />

//           <SystemExperience />
//           <CompetenciesScore profile={props.profile} />
//           <PersonalSkills profile={props.profile} />

//           <div className="row margin-row">
//             <div className="row-icon">
//               <img src="/assets/images/profile-page/icon9.png" alt="" />
//               {/* <img
//           className="completed"
//           src="/assets/images/profile-page/Recent_career_summary_active.svg"
//           alt=""
//         /> */}
//             </div>
//             <div className="col-12 ">
//               <DialogLeavingPage
//                 showDialog={showDialogLeavingPage}
//                 setShowDialog={setCanShowDialogLeavingPage}
//                 confirmNavigation={confirmNavigation}
//                 cancelNavigation={cancelNavigation}
//                 title={"Profile Section"}
//               />
//               <div className="timeline-border-box">
//                 <h5>Professional synopsis</h5>
                
//                 <div className="row">
//                   <div className="col ">
//                     <textarea
//                       name="professionalSynopsis"
//                       id="professionalSynopsis"
//                       className="form-control mh-215"
//                       placeholder="Short Summary"
//                       maxLength={1000} // HTML limit
//                       onChange={handleChangeProffesional}
//                       value={inputData.professionalSynopsis || ""} // Controlled input
//                     ></textarea>

                    

//                     <small
//                       style={{
//                         fontSize: "11px",
//                         display: "block",
//                         marginTop: "4px",
//                         color: professionalCharCount >= 1000 ? "red" : "#6c757d", // Red at limit
//                       }}
//                     >
//                       {professionalCharCount}/1000 characters used
//                     </small>

//                     <div className="col text-right ">
//                   {isEnable.proffesional_snyposis ? (
//                     <Link
//                       className="edit-btn"
//                       to=""
//                       onClick={handleProffesionalFormSubmit}
//                     >
//                       <span>
//                         <img src="/assets/images/icons/save.png" alt="" />
//                         Save
//                       </span>
//                     </Link>
//                   ) : (
//                     ""
//                   )}
//                 </div>

//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* <!-- Profile complete --> */}
//           <div className="row profile-complete">
//             <div className="col-md-6 offset-md-6 col-12 mb-4">
//               <div className="progress-widget">
//                 <label className="progress-label">PROFILE COMPLETE</label>
//                 <div className="progress-block">
//                   <div className="progress">
//                     <div
//                       className="progress-bar"
//                       role="progressbar"
//                       style={{ width: inputData.profile_fill + "%" }}
//                       aria-valuenow="100"
//                       aria-valuemin="0"
//                       aria-valuemax="100"
//                     ></div>
//                   </div>
//                   <span>{inputData.profile_fill}%</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* <!-- You are finished --> */}
//           <div className="row">
//             <div className="row-icon">
//               <img src="/assets/images/profile-page/icon10.png" alt="" />
//             </div>
//             <div className="col-12 finish-section">
//               <h5 className="mb-3">Start your energy sector journey:</h5>
//               <p>
//                 Enhance your Profile and your employment prospects.
//                 {/* <Link to="/user/analytics">
//                   MY analytics <span></span>
//                 </Link> */}
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="row cm-35">
//           <div className="col-12">
//             <ul className="quick-links ">
//               <li className="active">
//                 <div className="here-menu">
//                   <label>YOUR HERE</label>
//                   <img src="/assets/images/downround-icon.png" alt="" />
//                 </div>
//                 <Link to="/user/profile">
//                   <span className="icon-wrap">
//                     <img
//                       src="/assets/images/quick-links/profile-active.svg"
//                       alt=""
//                     />
//                   </span>
//                   <label className="blue">
//                     MY
//                     <br />
//                     <strong>Profile</strong>{" "}
//                   </label>
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/user/profile-analytics">
//                   <span className="icon-wrap">
//                     <img
//                       src="/assets/images/quick-links/analytics.svg"
//                       alt=""
//                     />
//                   </span>
//                   <label className="red">
//                     <strong>goneet</strong>
//                     <br />
//                     <span
//                       style={{
//                         backgroundColor: "#283270",
//                         color: "white",
//                         padding: "2px",
//                         borderRadius: "5px",
//                       }}
//                     >
//                       PRO
//                     </span>
//                   </label>
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/user/network">
//                   <span className="icon-wrap">
//                     <img src="/assets/images/quick-links/network.svg" alt="" />
//                   </span>
//                   <label className="orange">
//                     MY
//                     <br />
//                     <strong>Network</strong>{" "}
//                   </label>
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/user/performance">
//                   <span className="icon-wrap">
//                     <img
//                       src="/assets/images/quick-links/performance.svg"
//                       alt=""
//                     />
//                   </span>
//                   <label className="green">
//                     MY
//                     <br />
//                     <strong>Performance</strong>{" "}
//                   </label>
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>
//       <Modal
//         size="lg"
//         show={show}
//         onHide={() => setShow(false)}
//         aria-labelledby="example-modal-sizes-title-lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title id="example-modal-sizes-title-lg">
//             Upload Image
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ height: "40vh" }}>
//           <div style={imageContainerStyles}>
//             <Cropper
//               image={image}
//               crop={crop}
//               zoom={zoom}
//               aspect={540 / 360}
//               onCropChange={setCrop}
//               onCropComplete={onCropComplete}
//               onZoomChange={setZoom}
//             />
//           </div>
//         </Modal.Body>
//         <Modal.Body>
//           <div className="d-flex justify-content-between">
//             <div className="">
//               <label className="">
//                 <input
//                   type="file"
//                   id="upload-image"
//                   name="profile_pic"
//                   onChange={handleChangeImage}
//                 />
//               </label>
//             </div>
//             <div className="">
//               <span onClick={handeImageSubmit} className="save-button">
//                 <img
//                   src="/assets/images/icons/save.png"
//                   alt=""
//                   style={{ height: '30px', width: 'auto', verticalAlign: 'middle' }}
//                 />
//                 <span>Save</span>
//               </span>
//             </div>
//           </div>
//         </Modal.Body>

//       </Modal>
//     </UserLayout>
//   );
// };

// const mapStateToProps = (state) => {
//   const user = state.user.user;
//   const profile = state.user.profile;
//   const countries = state.admin.countries;
//   const sector = state.admin.sector;
//   const statutoryIndustry = state.admin.statutoryIndustry;
//   const phases = state.admin.phases;
//   const organisations = state.admin.organisations;
//   const competenciesScore = state.admin.competenciesScore;
//   const personalSkills = state.admin.personalSkills;
//   const qualifications = state.admin.qualifications;
//   const educations = state.admin.educations;
//   const functions = state.admin.functions;
//   const category = state.admin.category;
//   const jobTitles = state.admin.jobTitles;
//   const grade = state.admin.grade;
//   const region = state.admin.region;
//   const system = state.admin.system;
//   const systemExpereine = state.admin.systemExpereine;
//   const systemExpereineScoring = state.admin.systemExpereineScoring;

//   return {
//     user: user,
//     profile: profile,
//     countries: countries,
//     sector: sector,
//     statutoryIndustry: statutoryIndustry,
//     phases: phases,
//     organisations: organisations,
//     competenciesScore: competenciesScore,
//     personalSkills: personalSkills,
//     qualifications: qualifications,
//     educations: educations,
//     functions: functions,
//     category: category,
//     jobTitles: jobTitles,
//     grade: grade,
//     region: region,
//     system: system,
//     systemExpereine: systemExpereine,
//     systemExpereineScoring: systemExpereineScoring,
//   };
// };

// const mapDispatchToProps = (dispatch, state) => {
//   return {
//     fetchCountries: () => dispatch(fetchCountriesAction()),
//     fetchSector: () => dispatch(fetchSectorAction()),
//     fetchStatutoryIndustry: () => dispatch(fetchStatutoryIndustryAction()),
//     fetchPhases: () => dispatch(fetchPhasesAction()),
//     fetchOrganisation: () => dispatch(fetchOrganisationAction()),
//     fetchCompetenciesScore: () => dispatch(fetchCompetenciesScoreAction()),
//     fetchPersonalSkills: () => dispatch(fetchPersonalSkillsAction()),
//     fetchQualifications: () => dispatch(fetchQualificationsAction()),
//     fetchEducations: () => dispatch(fetchEducationsAction()),
//     fetchFunctions: () => dispatch(fetchFunctionsAction()),
//     fetchCategory: () => dispatch(fetchCategoryAction()),
//     fetchJobTitles: () => dispatch(fetchJobTitlesAction()),
//     fetchJobTitlesGrade: () => dispatch(fetchJobTitlesGrade()),
//     fetchRegion: () => dispatch(fetchRegion()),
//     fetchSystem: () => dispatch(fetchSystemAction()),
//     fetchSystemExperience: () => dispatch(fetchSystemExperienceAction()),
//     fetchSystemsExpereinceScoring: () =>
//       dispatch(fetchSystemsExpereinceScoringAction()),

//     // Profile
//     fetchProfile: () => dispatch(fetchProfileAction()),
//     updateProfile: () => dispatch(updateProfleAction()),
//     updateProflePicAction: () => dispatch(updateProflePicAction()),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(Profile);




/////////////////////////////////////////////////////////////////////////////////


import React, { useState, useEffect, useCallback } from "react";
import UserLayout from "../utils/user/UserLayout";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { IMAGEAPI } from "../../BackendConnections";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  fetchProfileAction,
  updateProfleAction,
  updateProflePicAction,
} from "../../redux/actions/user/userAction";
import {
  fetchCountriesAction,
  fetchSectorAction,
  fetchStatutoryIndustryAction,
  fetchPhasesAction,
  fetchOrganisationAction,
  fetchCompetenciesScoreAction,
  fetchPersonalSkillsAction,
  fetchQualificationsAction,
  fetchEducationsAction,
  fetchFunctionsAction,
  fetchCategoryAction,
  fetchJobTitlesAction,
  fetchSystemAction,
  fetchSystemExperienceAction,
  fetchSystemsExpereinceScoringAction,
  fetchJobTitlesGrade,
  fetchRegion,
} from "../../redux/actions/admin/adminAction";
import Sector from "./forms/Sector";
import Phase from "./forms/Phase";
import Organisation from "./forms/Organisation";
import Regions from "./forms/Regions";
import Function from "./forms/Function";
import Category from "./forms/Category";
import JobTitle from "./forms/JobTitle";
import EmploymentHistory from "./forms/EmploymentHistory";
import Qualification from "./forms/Qualification";
import StatutoryIndustryTraining from "./forms/StatutoryIndustryTraining";
import SystemExperience from "./forms/SystemExperience";
import CompetenciesScore from "./forms/CompetenciesScore";
import PersonalSkills from "./forms/PersonalSkills";
import { DialogLeavingPage } from "../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../utils/core/blocknavigation/useNavigatingAway";
import Modal from "react-bootstrap/Modal";
import Cropper from "react-easy-crop";
import { cropImage } from "./helper/cropUtils";
import { Button } from "react-bootstrap";
import getCroppedImg from "./helper/croperimg";
import axiosInstance from "../authentication/helper/axiosApi";
import axios from "axios";
// import './styleCroper.css'
import heic2any from "heic2any";
import imageCompression from "browser-image-compression";


export const Profile = (props) => {
  

  const dispatch = useDispatch();
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const [image, setImage] = useState(["/assets/images/preview-img.png"]);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [rotation, setRotation] = useState(0);
  const [inputData, setInputData] = useState({});

  const MAX_COMPANY_CHARS = 28;

  const [professionalCharCount, setProfessionalCharCount] = useState(0);






  // console.log(inputData);

  // const [isvalid, seIsvalid] = useState(true);

  const [isEnable, setIsEnable] = useState({
    profile_pic: false,
    save: false,
    proffesional_snyposis: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const [selected, setSelected] = useState({
    primary_sector: null,
    secondary_sector: null,
    primary_function: null,
    secondary_function: null,
  });

  // const [onChange, setOnChange] = useState({
  //     image: false,
  //     userDetails: false,
  //     sector: false,
  //     phase: false,
  //     organisation: false,
  //     region: false,
  //     function: false,
  //     category: false,
  //     jobTitle: false,
  //     qualification: false,
  //     statutory: false,
  //     systemsExperience: false,
  //     competenceScore: false,
  //     personalSkills: false,
  // });
  const [show, setShow] = useState(false);
  const [crop, setCrop] = useState({
    x: 0,
    y: 0,
    // width: 540,
    // height: 360,
  });
  const imageContainerStyles = {
    width: "auto !important",
    maxWidth: "100% !important",
    height: "auto !important",
  };
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  // console.log(croppedImage);
  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const profileDetails = {
        userId: props.profile.userId,
        first_name: props.profile.first_name,
        last_name: props.profile.last_name,
        location: props.profile.location,
        // telephone_number: props.profile.telephone_number,
        // phone_number: props.profile.phone_number,
        profile_pic: props.profile.profile_pic,
        professionalSynopsis: props.profile.professionalSynopsis,
        profile_fill: props.profile.profile_fill,
      };
      const selectedData = {
        primary_sector: props.profile.primary_sector,
        secondary_sector: props.profile.secondary_sector,
        primary_function: props.profile.primary_function,
        secondary_function: props.profile.secondary_function,
      };
      setSelected(selectedData);
      setInputData(profileDetails);
       // Initialize character count for Professional Synopsis
      setProfessionalCharCount(
        profileDetails.professionalSynopsis
          ? profileDetails.professionalSynopsis.length
          : 0
      );
    }

    if (props.profile.profile_pic !== null) {
      setImage(IMAGEAPI + props.profile.profile_pic);
    } else {
      setImage("/assets/images/preview-img.png");
    }
  }, [props.profile, props.profileData]);

  const handleChangeProffesional = (event) => {
    setIsEnable((prevState) => ({ ...prevState, proffesional_snyposis: true }));
    setCanShowDialogLeavingPage(true);

    const rawValue = event.target.value || "";
    const limitedValue = rawValue.slice(0, 1000); // Enforce 1000 characters

    setInputData((prevState) => ({
      ...prevState,
      [event.target.name]: limitedValue,
    }));

    // Update live character counter
    setProfessionalCharCount(limitedValue.length);
  };


  const handleProffesionalFormSubmit = (event) => {
    event.preventDefault();
    const profileDetails = {
      userId: inputData.userId,
      professionalSynopsis: inputData.professionalSynopsis,
    };
    dispatch(updateProfleAction(inputData.userId, profileDetails));
    setIsEnable((prevState) => ({
      ...prevState,
      proffesional_snyposis: false,
    }));
    setCanShowDialogLeavingPage(false);
  };

  //   const onCropComplete = (croppedArea, croppedAreaPixels) => {
  //     cropImage(image, croppedAreaPixels, console.log).then((result)   => {
  //       setCroppedImage(result);
  // // setImage(result)
  //       setInputData((prevData) => ({
  //         ...prevData,
  //         profile_pic: result,
  //       }));
  //     });
  //   };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
    // console.log(croppedAreaPixels);
    cropImage(image, croppedAreaPixels).then((result) => {
      setCroppedImage(result)

    })
  };

  // const handleChangeImage = (event) => {
  //   event.preventDefault();
  //   setIsEnable((prevState) => ({ ...prevState, profile_pic: true }));
  //   setCanShowDialogLeavingPage(true);
  //   const fieldName = event.target.getAttribute("name");
  //   const fieldValue = event.target.files[0];
  //   const newFormData = { ...props.profile };
  //   newFormData[fieldName] = fieldValue;
  //   const url = URL.createObjectURL(fieldValue);
  //   setImage(url);
  //   // console.log([event.target.name], event.target.files[0]);
  //   setInputData((prevState) => ({
  //     ...prevState,
  //     [event.target.name]: event.target.files[0],
  //   }));
  // };
  ////////////////////////////////
  const handleChangeImage = async (event) => {
  event.preventDefault();
  setIsEnable(prev => ({ ...prev, profile_pic: true }));
  setCanShowDialogLeavingPage(true);

  const file = event.target.files[0];
  if (!file) return;
  let convertedFile = file;

  // 🔥 If file is HEIC convert it to JPEG
  if (file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic")) {
    try {
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.9,
      });

      convertedFile = new File([blob], file.name.replace(/\.heic$/i, ".jpg"), {
        type: "image/jpeg",
      });

      console.log("HEIC converted to JPEG");
    } catch (error) {
      console.error("HEIC conversion failed:", error);
      return;
    }
  }

  // Continue with normal processing
  const url = URL.createObjectURL(convertedFile);
  setImage(url);

  setInputData(prev => ({
    ...prev,
    profile_pic: convertedFile,
  }));
};

  ////////////////////////////
  // console.log(inputData);

  // const handeImageSubmit = async () => {
  //   try {
  //     const imgUrl = {
  //       "profile_image": croppedImage
  //     }
  //     dispatch(
  //       updateProflePicAction(inputData.userId, imgUrl)
  //     );
  //     setShow(false)
  //   } catch (error) {
  //     console.error(error);
  //   }

  // }

  // const handeImageSubmit = async () => {
  //   console.log('croppedImage:', croppedImage);
  
  //   try {
  //     const img = new Image();
  //     img.onload = function () {
  //       console.log('Image loaded successfully');
  //       console.log('Image width:', img.width);
  //       console.log('Image height:', img.height);
  
  //       const imgUrl = {
  //         "profile_image": croppedImage,
  //         "Six-coordinates": {
  //           "width": img.width,
  //           "height": img.height,
  //           // Add other coordinates properties as needed
  //         },
  //       };
  
  //       dispatch(updateProflePicAction(inputData.userId, imgUrl));
  //       // --- FIX: Reset unsaved state here ---
  //       setIsEnable(prev => ({ ...prev, profile_pic: false }));
  //       setCanShowDialogLeavingPage(false);
  //       setShow(false);
  //     };
  
  //     img.onerror = function () {
  //       console.error('Error loading image:', croppedImage);
  //     };
  
  //     img.src = croppedImage;
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  /////////////////////////

//   const handeImageSubmit = async () => {
//   try {
//     console.log("croppedImage:", croppedImage);

//     // convert base64 cropped image → blob
//     const response = await fetch(croppedImage);
//     let blob = await response.blob();

//     // compress it
//     const compressedBlob = await imageCompression(blob, {
//       maxSizeMB: 1.9,
//       maxWidthOrHeight: 1500,
//       useWebWorker: true
//     });

//     // create file
//     const compressedFile = new File([compressedBlob], "profile.jpg", {
//       type: "image/jpeg",
//     });

//     // ❗ CREATE FORMDATA (this is REQUIRED)
//     const formData = new FormData();
//     formData.append("profile_image", compressedFile);
//     formData.append("Six-coordinates", JSON.stringify({
//       width: 600,
//       height: 600
//     }));

//     // send FormData
//     dispatch(updateProflePicAction(inputData.userId, formData));

//     setIsEnable(prev => ({ ...prev, profile_pic: false }));
//     setCanShowDialogLeavingPage(false);
//     setShow(false);

//   } catch (error) {
//     console.error("compression failed:", error);
//   }
// };


const handeImageSubmit = async () => {
  try {
    const response = await fetch(croppedImage);
    const blob = await response.blob();

    const compressedBlob = await imageCompression(blob, {
      maxSizeMB: 1.9,
      maxWidthOrHeight: 1500,
      useWebWorker: true
    });

    const compressedFile = new File([compressedBlob], "profile.jpg", {
      type: "image/jpeg",
    });

    dispatch(updateProflePicAction(inputData.userId, {
      profile_image: compressedFile,
      "Six-coordinates": { width: 600, height: 600 }
    }));
    setIsEnable(prev => ({ ...prev, profile_pic: false }));
    setCanShowDialogLeavingPage(false);
    setShow(false);

  } catch (err) {
    console.error(err);
  }
};


  
  
  
  

  const handleImageFormSubmit = (event) => {
    event.preventDefault();

    const profileDetails = {
      userId: inputData.userId,
      profile_pic: inputData.profile_pic,
    };
    // console.log(profileDetails);
    dispatch(
      // updateProflePicAction(inputData.userId, profileDetails, props.profile)
    );
    setIsEnable((prevState) => ({ ...prevState, profile_pic: false }));
    setCanShowDialogLeavingPage(false);
  };

  const [isValidForm, setIsValidForm] = useState(true);
  const [errors, setErrors] = useState({
    first_name_error: null,
  });

  const validateForm = (data) => {
    const obj = Object.keys(data);
    let checkValidation = true;
    obj.forEach((key, index) => {
      switch (key) {
        case "first_name":
          if (data[key] === null || data[key] === "") {
            setErrors({ first_name_error: "First Name is required!" });
            checkValidation = false;
          } else {
            setErrors({ first_name_error: null });
          }
          break;
        case "last_name":
          if (data[key] === null || data[key] === "") {
            setErrors({ last_name_error: "Last Name is required!" });
            checkValidation = false;
          } else {
            setErrors({ last_name_error: null });
          }
          break;
        case "location":
          break;
        case "telephone_number":
          break;
        case "phone_number":
          break;
        default:
          return isValidForm;
      }
    });

    if (checkValidation === false) {
      setIsValidForm(false);
    } else {
      setIsValidForm(true);
    }
  };

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    if (eventName === "location") {
      if (event != null) {
        setInputData((prevState) => ({
          ...prevState,
          [eventName]: event["id"],
        }));
      } else {
        setInputData((prevState) => ({ ...prevState, [eventName]: null }));
      }
    } else {
      setInputData((prevState) => ({
        ...prevState,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleInputChange = (inputValue) => {
    const searchValue = inputValue.toLowerCase();
    const filteredCountries = props.countries.filter((country) =>
      country.name.toLowerCase().includes(searchValue)
    );

    // Sort the filtered countries to prioritize options that start with the input value
    filteredCountries.sort((a, b) => {
      const aStartsWithInput = a.name.toLowerCase().startsWith(searchValue);
      const bStartsWithInput = b.name.toLowerCase().startsWith(searchValue);

      if (aStartsWithInput && !bStartsWithInput) {
        return -1;
      }
      if (!aStartsWithInput && bStartsWithInput) {
        return 1;
      }
      return 0;
    });

    setFilteredOptions(filteredCountries);
  };
  const handleChnageLocation = (event) => { };
  const [filteredOptions, setFilteredOptions] = useState(props.countries);
  const handleFormSubmit = (event) => {
    event.preventDefault();
    const profileDetails = {
      userId: inputData.userId,
      first_name: inputData.first_name,
      last_name: inputData.last_name,
      location: inputData.location,
      // telephone_number: inputData.telephone_number,
      // phone_number: inputData.phone_number,
    };
    validateForm(profileDetails);
    if (isValidForm) {
      dispatch(updateProfleAction(inputData.userId, profileDetails));
      setIsEnable((prevState) => ({ ...prevState, save: false }));
      setCanShowDialogLeavingPage(false);
    }
  };

  const handleChildrenCallback = (childData, childname) => {
    const name = childname;
    setSelected((prevState) => ({ ...prevState, [name]: childData }));
  };

  const fetchData = useCallback(() => {
    if (Object.keys(props.countries).length === 0) {
      props.fetchCountries();
    }
    if (Object.keys(props.sector).length === 0) {
      props.fetchSector();
    }
    if (Object.keys(props.statutoryIndustry).length === 0) {
      props.fetchStatutoryIndustry();
    }
    if (Object.keys(props.phases).length === 0) {
      props.fetchPhases();
    }
    if (Object.keys(props.phases).length === 0) {
      props.fetchOrganisation();
    }
    if (Object.keys(props.competenciesScore).length === 0) {
      props.fetchCompetenciesScore();
    }
    if (Object.keys(props.personalSkills).length === 0) {
      props.fetchPersonalSkills();
    }
    if (Object.keys(props.qualifications).length === 0) {
      props.fetchQualifications();
    }
    if (Object.keys(props.educations).length === 0) {
      props.fetchEducations();
    }
    if (Object.keys(props.functions).length === 0) {
      props.fetchFunctions();
    }
    if (Object.keys(props.category).length === 0) {
      props.fetchCategory();
    }
    if (Object.keys(props.jobTitles).length === 0) {
      props.fetchJobTitles();
    }
    if (Object.keys(props.grade).length === 0) {
      props.fetchJobTitlesGrade();
    }
    if (Object.keys(props.region).length === 0) {
      props.fetchRegion();
    }
    if (Object.keys(props.system).length === 0) {
      props.fetchSystem();
    }
    if (Object.keys(props.systemExpereine).length === 0) {
      props.fetchSystemExperience();
    }
    if (Object.keys(props.systemExpereineScoring).length === 0) {
      props.fetchSystemsExpereinceScoring();
    }
  }, [props]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <UserLayout>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="right-section">
        <div className="banner">
          <div className="banner-title-overlay">
            <h5>
              <span>
                MY
                <br />
                <b>Profile</b>
                <hr className="bannerhr"
                  style={{
                    height: "5px",
                    background: "white",
                    width: "75%",
                  }}
                />
              </span>
            </h5>
          <img src="/assets/images/banners/profWhiteIcon.png" className="icon-image" />
{" "}
            <div className="col-sm-6 col-12  title-icon-box text-center">
              <div className="text-center picture-area d-flex justify-content-center">
  <div>
                  <div className="profile-upload">
                    <div className="profile-preview  ">
                      <div className="img-wrap">
                        <div className="hexagon-wrap">
                          <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 120 90"
                          >
                            <defs>
                            <pattern id="imgupload-profile" patternUnits="userSpaceOnUse" width="150" height="100">
                                <image
                                  xlinkHref={image}
                                  x="-25"
                                  width="150"
                                  height="100"
                                  className="img-fluid"
                                ></image>
                              </pattern>
                            </defs>
                            <polygon fill="url(#imgupload-profile)" points="25.457,92.51 0.914,50 25.457,7.49 74.543,7.49 99.086,50 74.543,92.51 "></polygon>
                          </svg>
                        </div>
                      </div>
                      <label
                        className="upload-label "
                        htmlFor=""
                        onClick={() => setShow(true)}
                      >
                        {/* <input
                      type="file"
                      id="upload-image"
                      name="profile_pic"
                      onChange={handleChangeImage}
                      onClick={()=> setShow(true)}
                    />{" "} */}
                        Upload Your Image{" "}
                        <span>
                          {isEnable.profile_pic ? (
                            <Link
                              className="edit-btn"
                              to=""
                            // onClick={handleImageFormSubmit}
                            >
                              {/* <span>
                                <img
                                  src="/assets/images/icons/save.png"
                                  alt=""
                                />
                                Save
                              </span> */}
                            </Link>
                          ) : (
                            ""
                          )}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         <img className="banner-image" src="/assets/images/banners/Asset 1.png" alt="" />
        </div>
        

        <div className="row picture-area pb-3 mt-5">
          <div className="col-md-8 col-12">
            <div className="inner-content">
              <h6>Let’s get started</h6>
              <p style={{ fontSize: "16px" }}>
                Now develop your own goneet energy industry standard profile and{" "}
                establish your position within your own specific discipline.
              </p>
              {/* <div className="features">
                Create your profile and compare your CV’s strength against your
                peers.
              </div> */}
            </div>
          </div>
          <div className="col-md-4 col-12 mt-2 ">
            <div className="progress-widget" style={{ paddingRight: "50px" }}>
              {" "}
              <label className="progress-label">PROFILE PROGRESS</label>{" "}
              <div className="progress-block">
                {" "}
                <div className="progress">
                  {" "}
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: inputData.profile_fill + "%" }}
                    aria-valuenow="2"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>{" "}
                </div>{" "}
                <span>{inputData.profile_fill}%</span>{" "}
              </div>{" "}
            </div>
          </div>
        </div>

        <div className="profile-timeline">
          {/* <!-- Name --> */}
          <div className="row single-row">
            <div className="row-icon completed">
              {/* <img src="/assets/images/profile-page/my_profile.svg" alt="" /> */}
              <img
                // className="row-icon "
                // src="\assets\images\preview-img.png"
                // src="/assets/images/profile-page/profile.svg"
                src="\assets\images\quick-links\profile.svg"
                alt=""
                style={{ background: "white" }}
              />
            </div>
            <div className="col-12 mb-2">
              <label className="timeline-label ">Name</label>
            </div>
            <div className="col-md-6 col-12">
              <div className="single-field mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="First Name"
                  name="first_name"
                  id="first_name"
                  required
                  onChange={(event) => handleChange(event, "first_name")}
                  defaultValue={inputData.first_name}
                />
              </div>
              {errors.first_name_error !== null ? (
                errors.first_name_error
              ) : (
                <></>
              )}
            </div>
            <div className="col-md-6 col-12">
              <input
                type="text"
                className="form-control"
                placeholder="Last Name"
                name="last_name"
                id="last_name"
                onChange={(event) => handleChange(event, "last_name")}
                defaultValue={inputData.last_name}
              />
            </div>
            {errors.last_name_error !== null ? errors.last_name_error : <></>}
          </div>

          {/* <!-- Contact --> */}
          <div className="row single-row">
            <div className="row-icon completed">
              <img
                src="/assets/images/profile-page/contact_outline.svg"
                alt=""
              />
              {/* <img
                className="completed"
                src="/assets/images/profile-page/contact_outline.svg"
                alt=""
              /> */}
            </div>
            <div className="col-md-6 col-12">
              <label className="timeline-label m-0">Contact</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    onChange={(event) => handleChange(event, "email")}
                    placeholder="Example@gmail.com"
                    defaultValue={props.user.email}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12 cmb-25">
              <label className="timeline-label m-0">Location</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  {/* <Select
                    id="location"
                    name="location"
                    value={
                      props.countries &&
                      props.countries.find(
                        (country) => country.id === inputData.location
                      )
                    }
                    options={props.countries}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    onChange={(event) => handleChange(event, "location")}
                    placeholder="Choose..."
                    isClearable={true}
                    styles={customStyles}
                  /> */}
                  <Select
                    id="location"
                    name="location"
                    placeholder="Choose..."
                    isClearable={true}
                    styles={customStyles}
                    value={
                      props.countries &&
                      props.countries.find(
                        (country) => country.id === inputData.location
                      )
                    }
                    onChange={(event) => handleChange(event, "location")}
                    onInputChange={(inputValue, actionMeta) => {
                      handleInputChange(inputValue);
                    }}
                    options={filteredOptions} // Use the filteredOptions state here
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                  />
                </div>
              </div>
            </div>
            {/* <div className="col-12">
                            <div className="row">
                                <div className="col-md-6 col-12 single-item">
                                    <input type="number"
                                        name="telephone_number"
                                        className="form-control"
                                        placeholder="Telephone Number"
                                        onChange={(event) => handleChange(event, "telephone_number")}
                                        defaultValue={inputData.telephone_number}
                                    />
                                </div>
                                <div className="col-md-6 col-12 single-item">
                                    <input type="number"
                                        name="phone_number"
                                        className="form-control"
                                        placeholder="Phone Number"
                                        onChange={(event) => handleChange(event, "phone_number")}
                                        defaultValue={inputData.phone_number}
                                    />
                                </div>
                            </div>
                        </div> */}
          </div>
          <div className="row single-row-space">
            <div className="col text-right ">
              {isEnable.save ? (
                <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                  <span>
                    <img src="/assets/images/icons/save.png" alt="" />
                    Save
                  </span>
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>

          <Sector parentCallback={handleChildrenCallback} />

          <Phase
            primarySectorId={selected.primary_sector}
            secondarySectorId={selected.secondary_sector}
          />

          <Organisation
            primarySectorId={selected.primary_sector}
            secondarySectorId={selected.secondary_sector}
          />

          <Regions
            primarySectorId={selected.primary_sector}
            secondarySectorId={selected.secondary_sector}
          />

          <Function
            parentCallback={handleChildrenCallback}
            primarySectorId={selected.primary_sector}
            secondarySectorId={selected.secondary_sector}
          />

          <Category
            primaryFunctionId={selected.primary_function}
            secondaryFunctionId={selected.secondary_function}
            primarySectorId={selected.primary_sector}
            secondarySectorId={selected.secondary_sector}
          />

          <JobTitle
            primaryFunctionId={selected.primary_function}
            secondaryFunctionId={selected.secondary_function}
            primarySectorId={selected.primary_sector}
            secondarySectorId={selected.secondary_sector}
          />

          <EmploymentHistory
            primaryFunctionId={selected.primary_function}
            secondaryFunctionId={selected.secondary_function}
            primarySectorId={selected.primary_sector}
            secondarySectorId={selected.secondary_sector}
          />

          <Qualification qualificaions={props.qualificaions} />

          <StatutoryIndustryTraining
            primarySectorId={selected.primary_sector}
            secondarySectorId={selected.secondary_sector}
          />

          <SystemExperience />
          <CompetenciesScore profile={props.profile} />
          <PersonalSkills profile={props.profile} />

          <div className="row margin-row">
            <div className="row-icon">
              <img src="/assets/images/profile-page/icon9.png" alt="" />
              {/* <img
          className="completed"
          src="/assets/images/profile-page/Recent_career_summary_active.svg"
          alt=""
        /> */}
            </div>
            <div className="col-12 ">
              <DialogLeavingPage
                showDialog={showDialogLeavingPage}
                setShowDialog={setCanShowDialogLeavingPage}
                confirmNavigation={confirmNavigation}
                cancelNavigation={cancelNavigation}
                title={"Profile Section"}
              />
              <div className="timeline-border-box">
                <h5>Professional synopsis</h5>
                
                <div className="row">
                  <div className="col ">
                    <textarea
                      name="professionalSynopsis"
                      id="professionalSynopsis"
                      className="form-control mh-215"
                      placeholder="Short Summary"
                      maxLength={1000} // HTML limit
                      onChange={handleChangeProffesional}
                      value={inputData.professionalSynopsis || ""} // Controlled input
                    ></textarea>

                    

                    <small
                      style={{
                        fontSize: "11px",
                        display: "block",
                        marginTop: "4px",
                        color: professionalCharCount >= 1000 ? "red" : "#6c757d", // Red at limit
                      }}
                    >
                      {professionalCharCount}/1000 characters used
                    </small>

                    <div className="col text-right ">
                  {isEnable.proffesional_snyposis ? (
                    <Link
                      className="edit-btn"
                      to=""
                      onClick={handleProffesionalFormSubmit}
                    >
                      <span>
                        <img src="/assets/images/icons/save.png" alt="" />
                        Save
                      </span>
                    </Link>
                  ) : (
                    ""
                  )}
                </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Profile complete --> */}
          <div className="row profile-complete">
            <div className="col-md-6 offset-md-6 col-12 mb-4">
              <div className="progress-widget">
                <label className="progress-label">PROFILE COMPLETE</label>
                <div className="progress-block">
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: inputData.profile_fill + "%" }}
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <span>{inputData.profile_fill}%</span>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- You are finished --> */}
          <div className="row">
            <div className="row-icon">
              <img src="/assets/images/profile-page/icon10.png" alt="" />
            </div>
            <div className="col-12 finish-section">
              <h5 className="mb-3">Start your energy sector journey:</h5>
              <p>
                Enhance your Profile and your employment prospects.
                {/* <Link to="/user/analytics">
                  MY analytics <span></span>
                </Link> */}
              </p>
            </div>
          </div>
        </div>
        <div className="row cm-35">
          <div className="col-12">
            <ul className="quick-links ">
              <li className="active">
                <div className="here-menu">
                  <label>YOUR HERE</label>
                  <img src="/assets/images/downround-icon.png" alt="" />
                </div>
                <Link to="/user/profile">
                  <span className="icon-wrap">
                    <img
                      src="/assets/images/quick-links/profile-active.svg"
                      alt=""
                    />
                  </span>
                  <label className="blue">
                    MY
                    <br />
                    <strong>Profile</strong>{" "}
                  </label>
                </Link>
              </li>
              <li>
                <Link to="/user/profile-analytics">
                  <span className="icon-wrap">
                    <img
                      src="/assets/images/quick-links/analytics.svg"
                      alt=""
                    />
                  </span>
                  <label className="red">
                    <strong>goneet</strong>
                    <br />
                    <span
                      style={{
                        backgroundColor: "#283270",
                        color: "white",
                        padding: "2px",
                        borderRadius: "5px",
                      }}
                    >
                      PRO
                    </span>
                  </label>
                </Link>
              </li>
              <li>
                <Link to="/user/network">
                  <span className="icon-wrap">
                    <img src="/assets/images/quick-links/network.svg" alt="" />
                  </span>
                  <label className="orange">
                    MY
                    <br />
                    <strong>Network</strong>{" "}
                  </label>
                </Link>
              </li>
              <li>
                <Link to="/user/performance">
                  <span className="icon-wrap">
                    <img
                      src="/assets/images/quick-links/performance.svg"
                      alt=""
                    />
                  </span>
                  <label className="green">
                    MY
                    <br />
                    <strong>Performance</strong>{" "}
                  </label>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={show}
        onHide={() => setShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Upload Image
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "40vh" }}>
          <div style={imageContainerStyles}>
            <Cropper
              image={image}
              crop={crop}
              zoom={zoom}
              aspect={540 / 360}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div className="d-flex justify-content-between">
            <div className="">
              <label className="">
                <input
                  type="file"
                  id="upload-image"
                  name="profile_pic"
                  onChange={handleChangeImage}
                />
              </label>
            </div>
            <div className="">
              <span onClick={handeImageSubmit} className="save-button">
                <img
                  src="/assets/images/icons/save.png"
                  alt=""
                  style={{ height: '30px', width: 'auto', verticalAlign: 'middle' }}
                />
                <span>Save</span>
              </span>
            </div>
          </div>
        </Modal.Body>

      </Modal>
    </UserLayout>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const countries = state.admin.countries;
  const sector = state.admin.sector;
  const statutoryIndustry = state.admin.statutoryIndustry;
  const phases = state.admin.phases;
  const organisations = state.admin.organisations;
  const competenciesScore = state.admin.competenciesScore;
  const personalSkills = state.admin.personalSkills;
  const qualifications = state.admin.qualifications;
  const educations = state.admin.educations;
  const functions = state.admin.functions;
  const category = state.admin.category;
  const jobTitles = state.admin.jobTitles;
  const grade = state.admin.grade;
  const region = state.admin.region;
  const system = state.admin.system;
  const systemExpereine = state.admin.systemExpereine;
  const systemExpereineScoring = state.admin.systemExpereineScoring;

  return {
    user: user,
    profile: profile,
    countries: countries,
    sector: sector,
    statutoryIndustry: statutoryIndustry,
    phases: phases,
    organisations: organisations,
    competenciesScore: competenciesScore,
    personalSkills: personalSkills,
    qualifications: qualifications,
    educations: educations,
    functions: functions,
    category: category,
    jobTitles: jobTitles,
    grade: grade,
    region: region,
    system: system,
    systemExpereine: systemExpereine,
    systemExpereineScoring: systemExpereineScoring,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    fetchCountries: () => dispatch(fetchCountriesAction()),
    fetchSector: () => dispatch(fetchSectorAction()),
    fetchStatutoryIndustry: () => dispatch(fetchStatutoryIndustryAction()),
    fetchPhases: () => dispatch(fetchPhasesAction()),
    fetchOrganisation: () => dispatch(fetchOrganisationAction()),
    fetchCompetenciesScore: () => dispatch(fetchCompetenciesScoreAction()),
    fetchPersonalSkills: () => dispatch(fetchPersonalSkillsAction()),
    fetchQualifications: () => dispatch(fetchQualificationsAction()),
    fetchEducations: () => dispatch(fetchEducationsAction()),
    fetchFunctions: () => dispatch(fetchFunctionsAction()),
    fetchCategory: () => dispatch(fetchCategoryAction()),
    fetchJobTitles: () => dispatch(fetchJobTitlesAction()),
    fetchJobTitlesGrade: () => dispatch(fetchJobTitlesGrade()),
    fetchRegion: () => dispatch(fetchRegion()),
    fetchSystem: () => dispatch(fetchSystemAction()),
    fetchSystemExperience: () => dispatch(fetchSystemExperienceAction()),
    fetchSystemsExpereinceScoring: () =>
      dispatch(fetchSystemsExpereinceScoringAction()),

    // Profile
    fetchProfile: () => dispatch(fetchProfileAction()),
    updateProfile: () => dispatch(updateProfleAction()),
    updateProflePicAction: () => dispatch(updateProflePicAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
